import { isAbilityConditionLayer } from '../../compile/ability-conditions.js';
import { EXTRA_DAMAGE_REQUIRES_DAMAGE_TYPE } from './extra-damage-requires-damage-type.js';

/** Fragment fields consumed at roll time, plus compile gates / authoring metadata already folded into bucket entries. */
export const FRAGMENT_KNOWN_LAYERS: ReadonlySet<string> = new Set([
  'dice', 'die', 'mod', 'roll_type', 'damage_type', 'damage_heals_caster',
  'effect_ignores_damage_type_resistance',
  'buff_does_not_layer_onto_opposing_team', 'requires_class', 'requires_class_level', 'requires_subclass', 'requires_level',
  'enchantment_item_type', 'enchantment_weapon_classification', 'cost_gp', 'unenchantable',
  'triggers_when_caster_makes_roll_type', 'triggers_on_hit', 'triggers_on_critical_hit', 'triggers_if_roll_type_is_at_adv',
  'ability_works_only_against_creature_type', 'ability_does_not_work_against_creature_type', 'if_target_has_status_effect_active',
  'target_marked_by_caster', EXTRA_DAMAGE_REQUIRES_DAMAGE_TYPE,
  'weapon_attack_mod', 'bright_light_dim_light', 'enchantment_weapon_type',
]);

/** A status passive's conditions and aura-owner gate are evaluated before its fragment is planned. */
export const isStatusPassiveExtraDamageLayer = (name: string): boolean => FRAGMENT_KNOWN_LAYERS.has(name)
  || isAbilityConditionLayer(name) || name === 'if_aura_owner_has_status_effect_active';

export const EXTRA_DAMAGE_ROLL_TYPES: readonly string[] = ['9878714A-27C3-D737-88B3-E8C1EE63A20F', '42A38751-5549-CDE7-528E-AED309A2B07D'];
